<loading-indicator [show]="!formReady || saving"></loading-indicator>

<div [formGroup]="formData" class="generatedHTMLWindow generatedHTMLForm angularForm" *ngIf="formReady">
  <div class="formHeader">
    <span class="navigateBtn navigate-left" (click)="previous()" *ngIf="showPrevBtn && currentOid > 0">
      <svg-icon title="{{'navigation.previous' | translate | uppercase}}" src='./assets/icons/play.svg'></svg-icon>
    </span>
    <span class="headerTitle">{{ 'projectstd.projectDetails' | translate }}</span>
    <span class="navigateBtn navigate-right" (click)="next()" *ngIf="showNextBtn && currentOid > 0">
      <svg-icon title="{{'navigation.next' | translate | uppercase}}" src='./assets/icons/play.svg'></svg-icon>
    </span>
  </div>
  <div class="generatedHTMLRoot">
    <div class="mainSection" style="width: 50%">
      <div class="section" style="width: 50%">
        <div class="sectionTitleContainer">
          <span class="sectionTitle">{{ 'projectstd.projectInformation' | translate }}</span>
        </div>
        <div class="sectionRowContainer">
          <div class="sectionRow">
            <div class="sectionFieldContainer">
              <div class="field width50percent" *ngIf="formData.controls['Name'] as Name">
                <div class="labelContainer">
                  <span class="dialogLabel uppercase">{{ 'projectstd.name' | translate }}</span>
                  <span *ngIf="Name.invalid" class="invalid-asterisk"> *</span>
                </div>
                <div class="fieldContainer" [class.invalid-field]="Name.invalid">
                  <input type="text" formControlName="Name" kendoTextBox id="form-projectName" />
                </div>
              </div>
              <div class="field width50percent">
                <div class="labelContainer">
                  <span class="dialogLabel uppercase">{{ 'projectstd.oid' | translate }}</span>
                </div>
                <div class="fieldContainer">
                  <input *ngIf="!isNew" type="number" formControlName="Oid" kendoTextBox id="form-pUID" />
                  <input *ngIf="isNew" type="text" formControlName="filledOnSave" kendoTextBox id="form-pUID" />
                </div>
              </div>
              <div class="field width50percent">
                <div class="labelContainer">
                  <span class="dialogLabel uppercase">{{ 'projectstd.projectCoordinator' | translate }}</span>
                </div>
                <div class="fieldContainer">
                  <kendo-dropdownlist formControlName="projectCoordinatorId"
                                      [data]="config_user_projectCoordinator"
                                      textField="description"
                                      valueField="oid"
                                      [valuePrimitive]="true"
                                      id="form-projectCoordinator">
                  </kendo-dropdownlist>
                </div>
              </div>
              <div class="field width50percent">
                <div class="labelContainer">
                  <span class="dialogLabel uppercase">{{ 'projectstd.clientBusinessDevelopmentLead' | translate }}</span>
                </div>
                <div class="fieldContainer">
                  <kendo-dropdownlist formControlName="clientBusinessDevelopmentLeadId"
                                      [data]="config_user_clientBusinessDevelopmentLead"
                                      textField="description"
                                      valueField="oid"
                                      [valuePrimitive]="true"
                                      id="form-clientBusinessDevelopmentLead">
                  </kendo-dropdownlist>
                </div>
              </div>
              <div class="field width50percent" *ngIf="formData.controls['ClientManual'] as ClientManual">
                <div class="labelContainer">
                  <span class="dialogLabel uppercase">{{ 'projectstd.clientManual' | translate }}</span>
                  <span *ngIf="ClientManual.invalid" class="invalid-asterisk"> *</span>
                </div>
                <div class="fieldContainer" [class.invalid-field]="ClientManual.invalid">
                  <input type="text" formControlName="ClientManual" kendoTextBox id="form-clientmanual" />
                </div>
              </div>
              <div class="field width50percent">
                <div class="labelContainer">
                  <span class="dialogLabel uppercase">{{ 'projectstd.companyType' | translate }}</span>
                </div>
                <div class="fieldContainer">
                  <input type="text" formControlName="CompanyType" kendoTextBox id="form-companyType" />
                </div>
              </div>
              <div class="field width50percent" *ngIf="formData.controls['ImportConfigurationId'] as ImportConfigurationId">
                <div class="labelContainer">
                  <span class="dialogLabel uppercase">{{ 'projectstd.importFormat' | translate }}</span>
                  <span *ngIf="ImportConfigurationId.invalid" class="invalid-asterisk"> *</span>
                </div>
                <div class="fieldContainer" [class.invalid-field]="ImportConfigurationId.invalid">
                  <kendo-dropdownlist formControlName="ImportConfigurationId"
                                      [data]="reflistData.ref_import_configuration"
                                      textField="description"
                                      valueField="oid"
                                      [valuePrimitive]="true"
                                      id="importConfiguration">
                  </kendo-dropdownlist>
                </div>
              </div>
              <div class="field width50percent">
                <div class="labelContainer">
                  <span class="dialogLabel uppercase">{{ 'projectstd.projectPhaseValuationId' | translate }}</span>
                </div>
                <div class="fieldContainer">
                  <kendo-dropdownlist formControlName="ProjectPhaseValuationId"
                                      [data]="reflistData.ref_projectphasevaluation"
                                      textField="description"
                                      valueField="oid"
                                      [valuePrimitive]="true"
                                      id="form-projectPhase">
                  </kendo-dropdownlist>
                </div>
              </div>
              <div class="field width50percent">
                <div class="labelContainer">
                  <span class="dialogLabel uppercase">{{ 'projectstd.acquiredVia' | translate }}</span>
                </div>
                <div class="fieldContainer">
                  <kendo-dropdownlist formControlName="acquiredVia"
                                      [data]="reflistData.ref_l2_acquiredvia"
                                      textField="description"
                                      valueField="oid"
                                      [valuePrimitive]="true"
                                      id="form-acquiredvia">
                  </kendo-dropdownlist>
                </div>
              </div>
              <div class="field width50percent" *ngIf="formData.controls['ProjectStdNumberOfProperty'] as ProjectStdNumberOfProperty">
                <div class="labelContainer">
                  <span class="dialogLabel uppercase">{{ 'projectstd.projectStdNumberOfProperty' | translate }}</span>
                  <span *ngIf="ProjectStdNumberOfProperty.invalid" class="invalid-asterisk"> *</span>
                </div>
                <div class="fieldContainer" [class.invalid-field]="ProjectStdNumberOfProperty.invalid">
                  <kendo-numerictextbox formControlName="ProjectStdNumberOfProperty" format="n0" [spinners]="false" id="form-no-OfPropertiesManual"></kendo-numerictextbox>
                </div>
              </div>
              <div class="field width50percent">
                <div class="labelContainer">
                  <span class="dialogLabel uppercase">{{ 'projectstd.numberOfProperty' | translate }}</span>
                </div>
                <div class="fieldContainer">
                  <kendo-numerictextbox formControlName="NumberOfProperty" format="n0" [spinners]="false" id="form-numberOfProperty"></kendo-numerictextbox>
                </div>
              </div>
              <div class="field width50percent">
                <div class="labelContainer">
                  <span class="dialogLabel uppercase">{{ 'projectstd.valuationPurpose' | translate }}</span>
                </div>
                <div class="fieldContainer">
                  <kendo-dropdownlist formControlName="valuationPurpose"
                                      [data]="reflistData.ref_l2_valuationpurpose"
                                      textField="description"
                                      valueField="oid"
                                      [valuePrimitive]="true"
                                      id="form-valuationpurpose">
                  </kendo-dropdownlist>
                </div>
              </div>
              <div class="field width50percent">
                <div class="labelContainer">
                  <span class="dialogLabel uppercase">{{ 'projectstd.reportScope' | translate }}</span>
                </div>
                <div class="fieldContainer">
                  <kendo-dropdownlist formControlName="ReportScope"
                                      [data]="reflistData.ref_l2_projectstd_reportscope"
                                      textField="description"
                                      valueField="oid"
                                      [valuePrimitive]="true"
                                      id="form-reportscope">
                  </kendo-dropdownlist>
                </div>
              </div>
              <div class="field width50percent">
                <div class="labelContainer">
                  <span class="dialogLabel uppercase">{{ 'projectstd.specialAgreement' | translate }}</span>
                </div>
                <div class="fieldContainer">
                  <kendo-dropdownlist formControlName="SpecialAgreement"
                                      [data]="reflistData.ref_l2_projectstd_basicagreement"
                                      textField="description"
                                      valueField="oid"
                                      [valuePrimitive]="true"
                                      id="form-basicAgreement">
                  </kendo-dropdownlist>
                </div>
              </div>
              <ng-container *ngIf="formData.controls['SpecialAgreement'] as SpecialAgreement">
                <div class="field width50percent" *ngIf="SpecialAgreement.value == 1">
                  <div class="labelContainer">
                    <span class="dialogLabel uppercase">{{ 'projectstd.dueDateAgreement' | translate }}</span>
                  </div>
                  <div class="fieldContainer">
                    <kendo-datepicker formControlName="DueDateAgreement" [format]="dateFormat" id="form-dateOfBasicAgreement">
                    </kendo-datepicker>
                  </div>
                </div>
                <div class="field" [ngClass]="{'width50percent' : SpecialAgreement.value == 1,'width100percent' : SpecialAgreement.value != 1 }">
                  <div class="labelContainer">
                    <span class="dialogLabel uppercase">{{ 'projectstd.jjlJobId' | translate }}</span>
                  </div>
                  <div class="fieldContainer">
                    <input type="text" formControlName="JllJobId" kendoTextBox id="form-jll-job-id" />
                  </div>
                </div>
              </ng-container>
              <div class="field width100percent" style="height: 135px">
                <div class="labelContainer">
                  <span class="dialogLabel uppercase">{{ 'projectstd.otherRemarks' | translate }}</span>
                </div>
                <div class="fieldContainer">
                  <textarea formControlName="OtherRemarks"
                            rows="5"
                            id="form-commentsOtherRequirements">
                  </textarea>
                </div>
              </div>
              <div class="field width50percent" style="height: auto;">
                <div class="labelContainer">
                  <span class="dialogLabel uppercase">{{ 'projectstd.valuationMethodId' | translate }}</span>
                </div>
                <div class="fieldContainer">
                  <kendo-multiselect formControlName="ValuationMethodIds"
                                     [data]="reflistData.ref_l2_projectstd_valuationmethod"
                                     textField="description"
                                     valueField="oid"
                                     [valuePrimitive]="true"
                                     id="form-valuationMethod">
                  </kendo-multiselect>
                </div>
              </div>
              <div class="field width50percent" style="height: auto;">
                <div class="labelContainer">
                  <span class="dialogLabel uppercase">{{ 'projectstd.valuationLimitId' | translate }}</span>
                </div>
                <div class="fieldContainer">
                  <kendo-multiselect formControlName="ValuationLimitIds"
                                     [data]="reflistData.ref_l2_projectstd_valuationlimit"
                                     textField="description"
                                     valueField="oid"
                                     [valuePrimitive]="true"
                                     id="form-valuationLimits">
                  </kendo-multiselect>
                </div>
              </div>
              <div class="field width50percent" *ngIf="formData.controls['ValuationVolume'] as ValuationVolume">
                <div class="labelContainer">
                  <span class="dialogLabel uppercase">{{ 'projectstd.valuationVolumeManually' | translate }} | {{currency}}</span>
                  <span *ngIf="ValuationVolume.invalid" class="invalid-asterisk"> *</span>
                </div>
                <div class="fieldContainer" [class.invalid-field]="ValuationVolume.invalid">
                  <kendo-numerictextbox formControlName="ValuationVolume" format="n0" [spinners]="false" id="form-valuationvolumeManual"></kendo-numerictextbox>
                </div>
              </div>
              <div class="field width50percent">
                <div class="labelContainer">
                  <span class="dialogLabel uppercase">{{ 'projectstd.projectStdValuationVolumeCalc' | translate }} | {{currency}}</span>
                </div>
                <div class="fieldContainer">
                  <kendo-numerictextbox formControlName="ProjectStdValuationVolumeCalc" format="n0" [spinners]="false" id="form-projectStdValuationVolumeCalc"></kendo-numerictextbox>
                </div>
              </div>
              <div class="field width50percent">
                <div class="labelContainer">
                  <span class="dialogLabel uppercase">{{ 'projectstd.liabilityTypeId' | translate }}</span>
                </div>
                <div class="fieldContainer">
                  <kendo-dropdownlist formControlName="LiabilityTypeId"
                                      [data]="reflistData.ref_l2_liability_type"
                                      textField="description"
                                      valueField="oid"
                                      [valuePrimitive]="true"
                                      id="form-liabilityType">
                  </kendo-dropdownlist>
                </div>
              </div>
              <div class="field width50percent">
                <div class="labelContainer">
                  <span class="dialogLabel uppercase">{{ 'projectstd.raciTemplate' | translate }}</span>
                </div>
                <div class="fieldContainer">
                  <kendo-dropdownlist formControlName="RaciTemplateId"
                                      [data]="raciTemplates"
                                      textField="description"
                                      valueField="oid"
                                      [valuePrimitive]="true"
                                      id="form-racitemplates">
                  </kendo-dropdownlist>
                </div>
              </div>
              <div class="field width50percent">
                <div class="labelContainer">
                  <span class="dialogLabel uppercase">{{ 'projectstd.recordStatusId' | translate }}</span>
                </div>
                <div class="fieldContainer">
                  <kendo-dropdownlist formControlName="RecordStatusId"
                                      [data]="reflistData.ref_recordstatus"
                                      textField="description"
                                      valueField="oid"
                                      [valuePrimitive]="true"
                                      (ngModelChange)="datasetStatusUpdated($event)"
                                      id="form-recordStatus">
                  </kendo-dropdownlist>
                </div>
              </div>
              <div class="field width50percent" *ngIf="formData.controls['Portfolio'] as Portfolio">
                <div class="labelContainer">
                  <span class="dialogLabel uppercase">{{ 'projectstd.portfolio' | translate }}</span>
                  <span *ngIf="Portfolio.invalid" class="invalid-asterisk"> *</span>
                </div>
                <div class="fieldContainer" [class.invalid-field]="Portfolio.invalid">
                  <input type="text" formControlName="Portfolio" kendoTextBox id="form-portfolio" />
                </div>
              </div>
              <div class="field width50percent" *ngIf="formData.controls['Client'] as Client">
                <div class="labelContainer">
                  <span class="dialogLabel uppercase">{{ 'projectstd.client' | translate }}</span>
                  <span *ngIf="Client.invalid" class="invalid-asterisk"> *</span>
                </div>
                <div class="fieldContainer" [class.invalid-field]="Client.invalid">
                  <input type="text" formControlName="Client" kendoTextBox id="form-client" />
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="sectionTitleContainer">
          <span class="sectionTitle">{{ 'projectstd.valuationReportsDefaultConfiguration' | translate | uppercase}}</span>
        </div>
        <div class="sectionRowContainer">
          <div class="sectionRow">
            <div class="sectionFieldContainer">
              <div class="field width33percent">
                <div class="labelContainer">
                  <span class="dialogLabel uppercase">{{ 'projectstd.currency' | translate }}</span>
                </div>
                <div class="fieldContainer">
                  <kendo-dropdownlist formControlName="currencyId"
                                      [data]="reflistData.ref_currency_with_code"
                                      textField="description"
                                      valueField="oid"
                                      [valuePrimitive]="true"
                                      (ngModelChange)="onCurrencyChanged()"
                                      id="form-currency">
                  </kendo-dropdownlist>
                </div>
              </div>
              <div class="field width33percent">
                <div class="labelContainer">
                  <span class="dialogLabel uppercase">{{ 'projectstd.unitOfLength' | translate }}</span>
                </div>
                <div class="fieldContainer">
                  <kendo-dropdownlist formControlName="unitOfLengthId"
                                      [data]="reflistData.ref_unit_of_length"
                                      textField="description"
                                      valueField="oid"
                                      [valuePrimitive]="true"
                                      (ngModelChange)="onUnitOfLengthChanged()"
                                      id="form-ref_unitofLength">
                  </kendo-dropdownlist>
                </div>
              </div>
              <div class="field width33percent" *ngIf="formData.controls['DisplayValuesOverTimeId'] as DisplayValuesOverTimeId">
                <div class="labelContainer">
                  <span class="dialogLabel uppercase">{{ 'projectstd.displayValuesOverTimeId' | translate }}</span>
                  <span *ngIf="DisplayValuesOverTimeId.invalid" class="invalid-asterisk"> *</span>
                </div>
                <div class="fieldContainer" [class.invalid-field]="DisplayValuesOverTimeId.invalid">
                  <kendo-dropdownlist formControlName="DisplayValuesOverTimeId"
                                      [data]="reflistData.ref_l3_display_values_over_time"
                                      textField="description"
                                      valueField="oid"
                                      [valuePrimitive]="true"
                                      id="form-displayValuesOverTime">
                  </kendo-dropdownlist>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="section" style="width: 50%">
      <div class="sectionTitleContainer noBorder">
        <span class="sectionTitle">{{ 'projectstd.systemInformation' | translate | uppercase}}</span>
      </div>
      <div class="sectionRowContainer">
        <div class="sectionRow">
          <div class="sectionFieldContainer">
            <div class="field width50percent">
              <div class="labelContainer">
                <span class="dialogLabel uppercase">{{ 'projectstd.ownerUserId' | translate }}</span>
              </div>
              <div class="fieldContainer">
                <kendo-dropdownlist formControlName="OwnerUserId"
                                    [data]="reflistData.config_user"
                                    textField="description"
                                    valueField="oid"
                                    [valuePrimitive]="true"
                                    id="form-createdBy">
                </kendo-dropdownlist>
              </div>
            </div>
            <div class="field width50percent">
              <div class="labelContainer">
                <span class="dialogLabel uppercase">{{ 'projectstd.createdDate' | translate }}</span>
              </div>
              <div class="fieldContainer">
                <kendo-datepicker formControlName="CreatedDate" [format]="dateFormat" id="form-createdAt"></kendo-datepicker>
              </div>
            </div>
            <div class="field width50percent">
              <div class="labelContainer">
                <span class="dialogLabel uppercase">{{ 'projectstd.ownerBuId' | translate }}</span>
              </div>
              <div class="fieldContainer">
                <kendo-dropdownlist formControlName="OwnerBuId"
                                    [data]="reflistData.config_business_units"
                                    textField="description"
                                    valueField="oid"
                                    [valuePrimitive]="true"
                                    id="form-createdByBu">
                </kendo-dropdownlist>
              </div>
            </div>
            <div class="field width50percent">
              <div class="labelContainer">
                <span class="dialogLabel uppercase">{{ 'projectstd.modifiedByUserId' | translate }}</span>
              </div>
              <div class="fieldContainer">
                <kendo-dropdownlist formControlName="ModifiedByUserId"
                                    [data]="reflistData.config_user"
                                    textField="description"
                                    valueField="oid"
                                    [valuePrimitive]="true"
                                    id="form-modifiedBy">
                </kendo-dropdownlist>
              </div>
            </div>
            <div class="field width50percent">
              <div class="labelContainer">
                <span class="dialogLabel uppercase">{{ 'projectstd.historyLastEntryDate' | translate }}</span>
              </div>
              <div class="fieldContainer">
                <kendo-datepicker formControlName="HistoryLastEntryDate" [format]="dateFormat" id="form-modifiedAt"></kendo-datepicker>
              </div>
            </div>
            <div class="field width50percent">
              <div class="labelContainer">
                <span class="dialogLabel uppercase">{{ 'projectstd.modifiedBuId' | translate }}</span>
              </div>
              <div class="fieldContainer">
                <kendo-dropdownlist formControlName="ModifiedBuId"
                                    [data]="reflistData.config_business_units"
                                    textField="description"
                                    valueField="oid"
                                    [valuePrimitive]="true"
                                    id="form-modifiedByBu">
                </kendo-dropdownlist>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
